import { useTitle } from "react-use";

import { trpc } from "@blis/trpc/react";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { SubHeader } from "@/components/SubHeader";
import { Breadcrumb, Breadcrumbs } from "@/components/ui/breadcrumbs";
import { AccessionBoard } from "../components/AccessionBoard";
import { AccessionBoardProvider } from "../components/AccessionBoardProvider";
import { TimeframeSelect } from "../components/TimeframeSelect";
import { useTimeframe } from "../state";

export function BoardPage() {
  useTitle("Board");

  const { date } = useTimeframe();

  const { data, isLoading } = trpc.accession.list.all.useQuery({
    dateRange: date,
    filter: {
      status: ["new", "received", "in_progress", "completed"],
    },
  });

  return (
    <>
      <SubHeader>
        <SubHeader.Left>
          <Breadcrumbs>
            <Breadcrumb>Board</Breadcrumb>
          </Breadcrumbs>
        </SubHeader.Left>
        <SubHeader.Right>
          <TimeframeSelect />
        </SubHeader.Right>
      </SubHeader>
      <AccessionBoardProvider>
        <AccessionBoard accessions={data || []} loading={isLoading} />
      </AccessionBoardProvider>
      <CommandMenuProvider>
        <CommandMenu />
      </CommandMenuProvider>
    </>
  );
}
